import * as React from 'react';
import { Bem, addClass } from '../../utils';
import { useId } from '../../utils/hooks/useId';
import { Size } from '../../constants';
import './Paper.css';
const bem = Bem.create('vai-paper');
export const Paper = React.forwardRef(({ htmlId, dataTa, children, padding = Size.M, className, style, ...rest }, ref) => {
    const id = useId(htmlId, ['paper']);
    const paperClasses = addClass(bem.block(padding && `padding-${padding}`), className);
    return (React.createElement("div", Object.assign({ id: id.toString(), "data-ta": dataTa, ref: ref, className: paperClasses, style: style }, rest), children));
});
//# sourceMappingURL=Paper.js.map